<template>
    <div>
        <table class="table table-responsive d-md-table">
            <thead>
                <tr>
                    <th scope="col">
                        <select
                            ref="breakdownSelect"
                            class="form-select"
                            v-model="selectedBreakdown"
                        >
                            <option
                                v-for="type in breakdownTypes"
                                :key="type"
                                :value="type"
                            >
                                {{ labelizeGeneral(type) }}
                            </option>
                        </select>
                    </th>
                    <th scope="col" class="cursor-pointer" @click="toggleSort('score')">
                        Score
                        <i
                            class="fa"
                            :class="{
                                'fa-arrow-up': sortDirection == 'asc',
                                'fa-arrow-down': sortDirection == 'desc'
                            }"
                            v-if="activeSort == 'score'"
                        ></i>
                    </th>
                    <th scope="col" class="cursor-pointer" @click="toggleSort('responses')">
                        Responses
                        <i
                            class="fa"
                            :class="{
                                'fa-arrow-up': sortDirection == 'asc',
                                'fa-arrow-down': sortDirection == 'desc'
                            }"
                            v-if="activeSort == 'responses'"
                        ></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="breakdown in breakdowns" :key="breakdown.key">
                    <th scope="row">
                        <a class="blue-text" href="#" @click.prevent="goToResponses(breakdown)"> 
                            {{ labelizeData(breakdown.key, selectedBreakdown) }}
                        </a>
                    </th>
                    <td>{{ breakdown.averageScore }}</td>
                    <td>{{ breakdown.totalResponses }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import SurveysService from "../../services/surveys-service";
import LabelizeMixin from '../../mixins/LabelizeMixin.vue';

export default {
    mixins: [LabelizeMixin],
    props: {
        survey: {
            type: Object
        },
        fromDate: {
            type: Object
        },
        toDate: {
            type: Object
        },
        surveyField: {
            type: Object
        }
    },
    data() {
        return {
            breakdownTypes: ["language", "roomNumber", "nationality", "source"],
            breakdownData: null,
            selectedBreakdown: "language",
            activeSort: "responses",
            sortDirection: "desc"
        };
    },
    watch: {
        selectedBreakdown: {
            immediate: true,
            handler: async function(newVal, oldVal) {
                if (newVal) {
                    this.breakdownData = await this.getBreakdowns();
                }
            }
        }
    },
    methods: {
        goToResponses(breakdown) {
            let data = {
                dateRange: {
                    startDate: this.fromDate.toDate(),
                    endDate: this.toDate.toDate()
                }
            };
            data[this.selectedBreakdown] = breakdown.originalKey;
            data[this.selectedBreakdown + '_key'] = breakdown.key;
            this.$eventHub.$emit("applySurveyResponseFilters", data);
            $('.spark-settings-tabs a[href$="#responses"]').tab("show");
        },
        async getBreakdowns() {
            const from = this.fromDate.format("YYYY-MM-DD");
            const to = this.toDate.format("YYYY-MM-DD");

            return await SurveysService.surveyStatsBreakdown(
                this.survey.id,
                from,
                to,
                this.selectedBreakdown,
                this.surveyField.fieldId
            );
        },
        toggleSort(sort) {
            if (this.activeSort == sort) {
                this.sortDirection =
                    this.sortDirection == "asc" ? "desc" : "asc";
                return;
            }
            this.activeSort = sort;
            this.sortDirection = "desc";
        }
    },
    async mounted() {
        this.breakdownData = await this.getBreakdowns();
    },
    computed: {
        breakdowns() {
            if (!this.breakdownData) {
                return [];
            }
            var stats = this.breakdownData ? this.breakdownData.breakdowns : {};
            stats = Object.values(stats);

            const keys = {
                responses: 'totalResponses',
                score: 'averageScore'
            }
            const key = keys[this.activeSort];
            
            return stats.sort((a, b) => {
                const aValue = a[key];
                const bValue = b[key];
                if (aValue > bValue) {
                    return this.sortDirection == "desc" ? -1 : 1;
                }
                if (aValue < bValue) {
                    return this.sortDirection == "desc" ? 1 : -1;
                }
                return 0;
            });
        }
    }
};
</script>
